import styled from '@emotion/styled';

/**
 * Колонка «подпись + логотип».
 *
 * Прижата влево: без этого дети растягиваются на всю ширину поля, а карточка
 * внутри центрируется — логотип оказывался посреди пустой строки, тогда как
 * превью во всех остальных полях начинается от левого края.
 */
export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

/** По этому классу карточка находит иконку карандаша. */
export const EDIT_ICON_CLASS = 'logo-edit-icon';

/**
 * Карточка логотипа: наведение подсказывает, что фон можно поменять.
 *
 * Карандаш показывается правилом отсюда, а не из самой иконки: селектор по
 * стилизованному компоненту (`${PreviewFrame}:hover &`) работает только с
 * `@emotion/babel-plugin`, а в сборке проекта его нет — страница падает с
 * «Component selectors can only be used in conjunction with @emotion/babel-plugin».
 */
export const PreviewFrame = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.radii.card};
  transition: border-color 0.25s ease-in-out;

  &:hover {
    border-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
    cursor: pointer;
  }

  &:hover .${EDIT_ICON_CLASS}, &:focus-visible .${EDIT_ICON_CLASS} {
    opacity: 1;
  }
`;

export const EditIconSlot = styled.div`
  position: absolute;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
`;

export const BackgroundList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
`;

export const BackgroundCard = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px;

  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.AccentNaplesYellow : 'transparent')};
  border-radius: ${({ theme }) => theme.radii.card};
  cursor: pointer;
  transition: border-color 0.25s ease-in-out;

  &.hover:hover {
    border-color: ${({ theme, isActive }) => (isActive ? theme.colors.AccentNaplesYellow : theme.colors.AccentMediumChampagne)};
  }
`;

export const BackgroundPlate = styled.div<{ color?: string; imgUrl?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 94px;
  height: 62px;

  background: ${({ color, imgUrl }) => color ?? `url(${imgUrl}) -4px -4px`};
  background-size: auto;

  border: 1px solid ${({ theme }) => theme.colors.WhiteGray};
  border-radius: ${({ theme }) => theme.radii.card};
`;

export const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ColorRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

export const ColorDot = styled.div<{ color?: string; imgUrl?: string }>`
  width: 10px;
  height: 10px;

  background: ${({ color, imgUrl }) => color ?? `url(${imgUrl})`};
  background-size: 14px;

  border: 1px solid ${({ theme }) => theme.colors.WhiteGray};
  border-radius: ${({ theme }) => theme.radii.control};
`;
